import { motion } from "framer-motion";

// Masked line-by-line reveal. Pass an array of nodes, one per line.
export const KineticText = ({ lines, className = "", lineClassName = "", delay = 0.2 }) => (
  <motion.span
    className={`block ${className}`}
    initial="hidden"
    animate="show"
    variants={{
      hidden: {},
      show: { transition: { staggerChildren: 0.15, delayChildren: delay } },
    }}
  >
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
        <motion.span
          className={`block will-change-transform ${lineClassName}`}
          variants={{
            hidden: { y: "115%" },
            show: { y: "0%", transition: { duration: 1.1, ease: [0.22, 1, 0.36, 1] } },
          }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </motion.span>
);
